import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <CardsSection />
        <ContactSection />
        <MediaSection />
        <RankingSection />
        <IndexSection />
        <FaqSection />
        <CarouselSection />
        <FeaturesSection />
        <UpdatesSection />
        <TopicsSection />
        <AppSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}